import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, signInAnonymously } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAyUbGqBgTulVRCJtLy8AbJp3UC6hMHdMQ",
  authDomain: "createv-b669d.firebaseapp.com",
  projectId: "createv-b669d",
  storageBucket: "createv-b669d.appspot.com",
  messagingSenderId: "999822200666",
  appId: "1:999822200666:web:c2ce10bf062ac8c344ad63",
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Define the ensureAuthenticated function
const ensureAuthenticated = async () => {
  if (!auth.currentUser) {
    await signInAnonymously(auth);
  }
};

// Functions to handle 2FA state persistence
export function markUserAs2FARequired(userId) {
  localStorage.setItem(`2fa_required_${userId}`, "true");
}

export function isUserMarkedFor2FA(userId) {
  const storedValue = localStorage.getItem(`2fa_required_${userId}`);
  return storedValue === "true";
}

export function clearUserFrom2FARequired(userId) {
  localStorage.removeItem(`2fa_required_${userId}`);
}

export { db, storage, auth, ensureAuthenticated };
